function template(templateString) {
    _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    return _.template(templateString);
}

function trim(value, chars) {
    return _.trim(value, chars);
}

function trimStart(value, chars) {
    return _.trimStart(value, chars);
}

function trimEnd(value, chars) {
    return _.trimEnd(value, chars);
}

function pad(value, chars) {
    return _.pad(value, chars);
}

function padStart(value, chars) {
    return _.padStart(value, chars);
}

function padEnd(value, chars) {
    return _.padEnd(value, chars);
}

export {
    template,
    trim,
    trimStart,
    trimEnd,
    pad,
    padStart,
    padEnd,
};



// WEBPACK FOOTER //
// ./src/utils/ec-string.js